<template>
    <div v-if="edit">
        <m-text v-model="localValue" @enter="update"></m-text>
        <div class="block"></div>
        <div class="btn btn-primary inline-block" @click="update">Update</div>
        <div class="btn btn-primary inline-block" @click="cancel">Cancel</div>
    </div>
    <div v-else @click="edit = true">
        <div class="text-base inline">{{ value }}</div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    name: "editcell",
    data() {
        return {
            edit: false,
            localValue: this.value
        }
    },
    methods: {
        cancel() {
            this.edit = false
            this.localValue = this.value
        },
        update() {
            this.$emit('update', this.localValue)
            this.edit = false
        }
    }
}
</script>

<style scoped>

</style>